export default (state) => state?.appState?.previewDate;
